import React from 'react';
import PropTypes from 'prop-types';

function BaseText({
  title,
  className,
  textColor,
  textAlign,
  fontWeight,
  link,
  lineHeight,
  fontSize,
  style,
  letterSpacing
}) {
  return (
    <div className={`${className}`}>
      <p
        className={`${fontWeight} ${fontSize} ${textColor} ${textAlign} ${
          link ? 'link-class' : 'no-link'
        } ${letterSpacing} ${lineHeight}`}
        style={style}
      >
        {title}
      </p>
    </div>
  );
}

export default BaseText;

BaseText.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  textColor: PropTypes.string,
  textAlign: PropTypes.string,
  fontWeight: PropTypes.string,
  link: PropTypes.bool,
  lineHeight: PropTypes.string,
  fontSize: PropTypes.string,
  style: PropTypes.any,
  letterSpacing: PropTypes.string
};

BaseText.defaultProps = {
  textColor: 'text-gray-300',
  textAlign: 'text-left',
  fontWeight: 'text-regular',
  lineHeight: 'leading-5',
  fontSize: 'text-xl',
  letterSpacing: 'letter-spacing-p'
};
